import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import SportCouponPageImpl from './sport-coupon-page.js';

const UIPage = MojitoCore.Presentation.UIPage;

/**
 * @namespace SportCouponPage
 * @memberof Mojito.Applications.Sports.Pages
 */

/**
 * Page displaying a sport coupon.
 *
 * @class SportCouponPage
 * @extends Mojito.Core.Presentation.UIPage
 * @memberof Mojito.Applications.Sports.Pages.SportCouponPage
 */

/**
 * SportCouponPage prop types.
 *
 * @property {string} [defaultSportId] - Fallback sport id when the route has no sport segment and the coupon id does not encode one.
 *
 * @memberof Mojito.Applications.Sports.Pages.SportCouponPage
 */
const propTypes = {
    defaultSportId: PropTypes.string,
};

export default UIPage('SportCouponPage', SportCouponPageImpl, propTypes);
